import { getEnumDesc } from './enum'

/**
 * 格式化工具类
 */

// 字典列表
export default {

  /**
   * 格式枚举描述
   * @param className 类
   * @param name 枚举名
   */
  formatEnumDesc(className, name) {
    return getEnumDesc(className, name)
  },

  /**
   * 格式boolean值
   * @param booleanVal
   * @returns {string|string}
   */
  formatBoolean(booleanVal) {
    if (booleanVal == null) {
      return ''
    }
    return booleanVal ? '是' : '否'
  },

  /**
   * 将 Date 转化为指定格式的string(本地时间)
   * @function formatDate
   * @param {Date} date
   * @param {string} [fmt=yyyy-MM-dd HH:mm:ss]
   * @returns {String}
   */
  formatDate(date, fmt) {
    if (!date || isNaN(date)) return ''
    if (!fmt) fmt = 'yyyy-MM-dd HH:mm:ss'
    const o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
      'H+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds() // 秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return fmt
  },

  /**
   * 添加货币符号
   * @param amount 金额
   * @returns {string}
   */
  currency(amount) {
/*    if (amount == null) {
      return ''
    }
    if (isNaN(amount)) {
      return '￥0'
    }
    return '￥' + amount*/
    return amount;
  }

}

